// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { HideToast, ShowToast } from '@actions/toast';

/** Optional in-app link under the message, e.g. "Buy credits" → billing. */
export interface ToastAction {
  label: string;
  to: string;
}

export interface ToastItem {
  id: number;
  title: string;
  message: string;
  action?: ToastAction;
}

export interface ToastState {
  toasts: ToastItem[];
  nextId: number;
}

interface ShowToastPayload {
  title: string;
  message: string;
  action?: ToastAction;
}

interface HideToastPayload {
  id: number;
}

const MAX_TOASTS = 3;

const initialState: ToastState = {
  toasts: [],
  nextId: 1,
};

export default handleActions<ToastState, ShowToastPayload | HideToastPayload>(
  {
    [ShowToast.toString()]: (
      state: ToastState,
      { payload }: Action<ShowToastPayload>,
    ): ToastState => {
      // Deduplicate: skip if toast with same message already exists
      const isDuplicate = state.toasts.some(
        (t) => t.message === payload.message,
      );
      if (isDuplicate) return state;

      const newToast: ToastItem = {
        id: state.nextId,
        title: payload.title,
        message: payload.message,
        action: payload.action,
      };
      const toasts = [...state.toasts, newToast].slice(-MAX_TOASTS);
      return {
        toasts,
        nextId: state.nextId + 1,
      };
    },
    [HideToast.toString()]: (
      state: ToastState,
      { payload }: Action<HideToastPayload>,
    ): ToastState => ({
      ...state,
      toasts: state.toasts.filter((t) => t.id !== payload.id),
    }),
  },
  initialState,
);
